import styled, { createGlobalStyle, css } from 'styled-components'

export const ResultToolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;

  button {
    padding: 10px 18px;
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.surfaceElevated};
    color: inherit;
    font-weight: bold;
    cursor: pointer;
  }

  button:hover {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`

export const WarningList = styled.ul`
  margin: 12px 0 0;
  padding: 12px 16px 12px 32px;
  border: 1px solid #f59e0b;
  border-radius: 8px;
  background-color: rgba(245, 158, 11, 0.12);
  font-size: 0.9rem;

  li + li {
    margin-top: 4px;
  }
`

export const TabList = styled.div.attrs({ role: 'tablist' })`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 16px 0;
`

export const Tab = styled.button.attrs({ type: 'button', role: 'tab' })`
  padding: 8px 16px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.surfaceElevated};
  color: inherit;
  cursor: pointer;

  ${({ $depth }) => css`
    margin-left: ${$depth * 8}px;
  `}

  ${({ $active, theme }) =>
    $active &&
    css`
      border-color: ${theme.colors.primary};
      background-color: ${theme.colors.primary};
      color: #fff;
      font-weight: bold;
    `}
`

export const TabPanel = styled.div.attrs({ role: 'tabpanel' })`
  display: ${({ $active }) => ($active ? 'block' : 'none')};
`

// Na impressão, mostra todos os quadros e apenas a área do resultado.
export const PrintStyles = createGlobalStyle`
  @media print {
    body * {
      visibility: hidden;
    }

    [data-print-area],
    [data-print-area] * {
      visibility: visible;
    }

    [data-print-area] {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }

    [data-print-area] [role='tablist'],
    [data-print-area] [data-no-print] {
      display: none !important;
    }

    [data-print-area] [role='tabpanel'] {
      display: block !important;
      break-inside: avoid-page;
      margin-bottom: 24px;
    }
  }
`
